import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
//import ReactDOM from 'react-dom';
//import axios from 'axios';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';

//import './css/index.css';
//import './css/header.css';

export default class AccountLogin extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
		let url = window.location.pathname.split('/');
    this.state = {
			status: true,

      key: url[2]?url[2]:'', //this.props.match.params.key,

			password: {
				text: '',
				valid: false,
				error: '',
				visible: false,
			},
      error: false,
			cookies: navigator.cookieEnabled,
			version: url[2]?'Recover':'Password'
		};
		//this.getUser = this.getUser.bind(this);
		this.changeVersion = this.changeVersion.bind(this);
    this.recover = this.recover.bind(this);
    this.handleChange = this.handleChange.bind(this);
		this.passwordVisability = this.passwordVisability.bind(this);
    this.changePassword = this.changePassword.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});


		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}


	/*getUser = (e) => {
    this.setState({await: true});
    e.preventDefault();
    const params = new URLSearchParams();
    params.append('username', e.target.elements.username.value);
    params.append('password', e.target.elements.password.value);
    params.append('remember', e.target.elements.remember.checked);
    params.append('cookie', localStorage.getItem('cookie'));
    if(this.state.totp === true)
    params.append('totp', e.target.elements.totp.value);
    axios.post(`/v3/account/login`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true
    })
    .then((res) => {
      if( res.data.error ) {
        if( res.data.error === "Recover" ) {
          window.location.href = '/recover';  
        } else {
          const element = res.data.error;
          ReactDOM.render( element, document.getElementById('error') );
          this.setState({await: false, totp: false});
        }
      } else {
        //EventEmitter.emit('/syncerror', {show: false});
				EventEmitter.emit('/socket/reconnect', {data: 'no value'});
				/*try{ 
        	this.props.history.push('/');
				} catch(error) {
					window.location.href = '/mchat';
				}*
				window.location.href = `/`;
      }
    })
    .catch(error => {
      if (error.message === "Network Error"){
				//EventEmitter.emit('/syncerror', {show: true});
				setTimeout(_ => {
        	this.getUser(e);
      	}, 5000);
			}
      /*if( error.response.status === 403 ) {
        this.setState({await: false, totp: true});
      }*
    });
  }*/

	async changeVersion() {
		let version = this.state.version;
		if( version === 'Password' ) {
			version = 'Username';
		} else {
			version = 'Password';
		}
		this.setState({version});
	}


  async recover(e) {
    e.preventDefault();
    if( document.getElementById("email").value === null || document.getElementById("email").value === '' ) return;
    const params = new URLSearchParams();
    params.append('action', this.state.version);
		params.append('email', document.getElementById("email").value);
		const x = await postApi('/v3/account/recover', params);
    this.setState({error: x.status===200?false:x.data.message});
  }
	
  handleChange(event) {
		var item = event.target.value;
		if( event.target.name === "password" ) {
			const decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,40}$/;
			let password = this.state.password;
			password.text = item;
			password.valid = decimal.test(String(item));
			if( !password.valid ) {
				password.error = 'Requires a Capital, Number and a Special character';
			} else {
				password.error = ''
			}
			if(item.length < 8 || item.length > 40 ) {
				password.valid = false;
				password.error = 'Requires 8 to 40 characters';
			}
      this.setState({password});
		}
	}

	passwordVisability() {
		let password = this.state.password;
		password.visible = !password.visible;
		this.setState({password});
	}

  async changePassword(e) {
    e.preventDefault();
    const params = new URLSearchParams();
    params.append('key', this.state.key);
		params.append('password', this.state.password.text);
		const x = await putApi('/v3/account/recover', params);
    if( x.status === 200 ) {
      window.location.href = '/';
    }
  }

	render() {
		
		return (
			<>
				<div className="container">
					
					<div className="row justify-content-center">
						<div className="col-xl-8 col-md-12 col-sm-10" style={{userSelect: 'none'}}>
							<div className="card custom-card  rectangle2">
								<div className="card-body p-0 ">
									<div className="row">
										<div className="col-xl-6 col-md-6 pe-sm-0">
                      {this.state.version==='Recover' ?
                        <Form onSubmit={this.changePassword}>
                          <div className="p-sm-5 p-3">
                            <p className="h4 fw-semibold mb-2">Reset Password</p>
                            <p className="mb-3 text-muted op-7 fw-normal">Recover your account!</p>
                            <p id="error" className="text-secondary fw-semibold">&nbsp;</p>
                            <div className="row gy-3 mt-3">
                              {/*<div className="col-xl-12 mt-0">
                                <label htmlFor="signin-email" className="form-label text-default d-block">Email Address<Link to="#" onClick={()=>this.changeVersion()} className="float-end text-primary">Forget {this.state.version==='Password'?'Username':'Password'} ?</Link></label>
                                <input type="text" className="form-control form-control-lg" id="email" placeholder="Email Address" name="email" required />
                              </div>*/}
                              <div className="col-xl-12 mb-3">
                                <label htmlFor="signin-password" className="form-label text-default d-block">Password 
                                  {this.state.password.valid===true&&this.state.password.text.length>0&&<>&nbsp;<span className="badge rounded-pill bg-success-gradient p-1"><FontAwesomeIcon icon="check" style={{color: '#ffffff'}} /></span></>}
                                </label>
                                {this.state.password.valid === false && this.state.password.text.length > 0 &&
                                  <label htmlFor="password" className="form-label text-secondary fw-semibold">&nbsp;* {this.state.password.error}</label>
                                }
                                <div className="input-group">
                                  <FormControl type={this.state.password.visible?'text':'password'} name="password" id="password" onChange={this.handleChange} value={this.state.password.text} placeholder="Password" aria-label="Password" aria-describedby="Password" required />
                                  <button className="btn btn-light bg-transparent" type="button" onClick={this.passwordVisability} id="button-addon2"><FontAwesomeIcon icon={this.state.password.visible===true?'eye':'eye-slash'} /> <i className="ri-eye-off-line align-middle"></i></button>
                                </div>
                              </div>
                              {this.state.cookies === false ?
                                <p className="my-1" style={{color: '#ff0000'}}>
                                  * You need cookies enabled to use this site
                                </p>
                              :
                                <div className="col-xl-12 d-grid mt-3">
                                  <Button type="submit" onClick={this.changePassword}>Change Password</Button>
                                </div>
                              }
                              {this.state.error &&
                                <div className="col-xl-12 mt-3">
                                  <div className="alert alert-danger">
                                  
                                  * {this.state.error}
                                  </div>
                                </div>
                              }
                            </div>
                            {/*
                            <div className="text-center my-4 authentication-barrier">
                              <span>OR</span>
                            </div>
                            <div className="btn-list text-center">
                              <button className="btn btn-light "><svg className="google-svg" xmlns="http://www.w3.org/2000/svg" width="2443" height="2500" preserveAspectRatio="xMidYMid" viewBox="0 0 256 262"><path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"></path><path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"></path><path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"></path><path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"></path></svg>Sign In with google</button>                                    <button className="btn btn-icon btn-light btn-wave waves-effect waves-light"> <i className="ri-facebook-line fw-bold "></i> </button> <button className="btn btn-icon btn-light btn-wave waves-effect waves-light"> <i className="ri-twitter-line fw-bold "></i> </button>
                            </div>
                            */}
                            <div className="text-center ">
                              <p className="fs-12 text-muted mt-4 mb-0">Dont have an account? <Link to="/register" className="text-primary">Sign Up</Link></p>
                            </div>
                          </div>
                        </Form>
                      :
                        <Form onSubmit={this.recover}>
                          <div className="p-sm-5 p-3">
                            <p className="h4 fw-semibold mb-2">Forgot {this.state.version}</p>
                            <p className="mb-3 text-muted op-7 fw-normal">Recover your account!</p>
                            <p id="error" className="text-secondary fw-semibold">&nbsp;</p>
                            <div className="row gy-3 mt-3">
                              <div className="col-xl-12 mt-0">
                                <label htmlFor="signin-email" className="form-label text-default d-block">Email Address<Link to="#" onClick={()=>this.changeVersion()} className="float-end text-primary">Forget {this.state.version==='Password'?'Username':'Password'} ?</Link></label>
                                <input type="text" className="form-control form-control-lg" id="email" placeholder="Email Address" name="email" required />
                              </div>
                              {/*<div className="col-xl-12 mb-3">
                                <label htmlFor="signin-password" className="form-label text-default">Password</label>
                                <div className="input-group">
                                  <input type={this.state.password.visible===true?'text':'password'} className="form-control form-control-lg" id="signin-password" placeholder="password" name="password" required />
                                  <button className="btn btn-light bg-transparent" type="button" onClick={this.passwordVisability} id="button-addon2"><FontAwesomeIcon icon={this.state.password.visible===true?'eye':'eye-slash'} /> <i className="ri-eye-off-line align-middle"></i></button>
                                </div>
                                <div className="mt-2">
                                  <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" name="remember" />
                                    <label className="form-check-label text-muted fw-normal" htmlFor="defaultCheck1"> Remember password ? </label>
                                  </div>
                                </div>
                              </div>*/}
                              {this.state.cookies === false ?
                                <p className="my-1" style={{color: '#ff0000'}}>
                                  * You need cookies enabled to use this site
                                </p>
                              :
                                <div className="col-xl-12 d-grid mt-3">
                                  <Button type="submit" onClick={this.recover}>Recover {this.state.version}</Button>
                                </div>
                              }
                              {this.state.error &&
                                <div className="col-xl-12 mt-3">
                                  <div className="alert alert-danger">
                                  
                                  * {this.state.error}
                                  </div>
                                </div>
                              }
                            </div>
                            {/*
                            <div className="text-center my-4 authentication-barrier">
                              <span>OR</span>
                            </div>
                            <div className="btn-list text-center">
                              <button className="btn btn-light "><svg className="google-svg" xmlns="http://www.w3.org/2000/svg" width="2443" height="2500" preserveAspectRatio="xMidYMid" viewBox="0 0 256 262"><path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"></path><path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"></path><path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"></path><path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"></path></svg>Sign In with google</button>                                    <button className="btn btn-icon btn-light btn-wave waves-effect waves-light"> <i className="ri-facebook-line fw-bold "></i> </button> <button className="btn btn-icon btn-light btn-wave waves-effect waves-light"> <i className="ri-twitter-line fw-bold "></i> </button>
                            </div>
                            */}
                            <div className="text-center ">
                              <p className="fs-12 text-muted mt-4 mb-0">Dont have an account? <Link to="/register" className="text-primary">Sign Up</Link></p>
                            </div>
                          </div>
                        </Form>
                      }
											
										</div>
										<div className="col-xl-6 col-md-6 ps-0 text-fixed-white rounded-0 d-none d-md-block  ">
											<div className="card custom-card mb-0 cover-background overflow-hidden rounded-end rounded-0">
												<div className="card-img-overlay d-flex  align-items-center p-0 rounded-0">
													<div className="card-body p-5 rectangle3">
														<div>
															<a href="index.html"> <img src="../assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" /></a>
														</div>
														<h6 className="mt-4 fs-15 op-9  text-fixed-white">Sign In</h6>
														<div className="d-flex mt-3">
															<p className="mb-0 fw-normal fs-14 op-7  text-fixed-white"> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsa eligendi expedita aliquam quaerat nulla voluptas facilis. Porro rem voluptates possimus, ad, autem quae culpa architecto, quam labore blanditiis at ratione.</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}